<template>
  <v-list-group no-action :ripple="false">
    <template v-slot:activator>
      <v-list-item-title class="text-none subtitle-2 font-weight-medium">Colección de métricas</v-list-item-title>
    </template>
    <v-list-item class="pl-4" v-for="item in collection" exact :key="item.metrics" :ripple="false" :to="{ name: 'MetricList', query: { ref: item.category } }">
      <v-list-item-title class="text-none body-2 font-weight-medium">{{item.category}}</v-list-item-title>
    </v-list-item>
  </v-list-group>
</template>
<script>
import metrics from '@/collections/metrics'
import { uniqBy } from 'lodash'

export default {
  data: () => ({
    metrics: metrics
  }),
  computed: {
    collection () {
      let result = []
      result = uniqBy(this.metrics, 'category')
      return result.filter(item => item.category !== '')
    }
  }
}
</script>